// LINKS page (/links) — owner rule (2026-09-10): "every table has Add and
// Edit." Replaces the hard-coded ME_LINKS/OUR_LINKS in managerLogins.ts with
// a real table (login_link, 077_login_link.sql). Mirrors licenses.ts's own
// shape: fetch-all-once, no per-clinic key — a login link has no clinic at
// all, so there is nothing to filter by.
import { authedGet, authedWrite } from './apiClient';
import { persistResource } from './store';

export const LOGIN_LINKS_KEY = 'login-links';

export type LoginLinkGroup = 'me' | 'our';
export type LoginLinkSize = 'lg' | 'md' | 'sm';

export interface LoginLinkRow {
  id: number;
  group: LoginLinkGroup;
  label: string;
  href: string;
  size: LoginLinkSize;
  sortOrder: number;
}

export interface LoginLinksData {
  rows: LoginLinkRow[];
}

export function fetchLoginLinks(): Promise<LoginLinksData> {
  return authedGet('/api/v1/login-links');
}

export async function reloadLoginLinks(): Promise<void> {
  const data = await fetchLoginLinks();
  await persistResource(LOGIN_LINKS_KEY, data);
}

export type LoginLinkWrite = {
  label: string;
  href: string;
  group: LoginLinkGroup;
  size: LoginLinkSize;
  sortOrder: number;
};

export async function addLoginLink(body: LoginLinkWrite): Promise<{ link: LoginLinkRow }> {
  return authedWrite('POST', '/api/v1/login-links', body);
}

export async function updateLoginLink(id: number, body: LoginLinkWrite): Promise<{ link: LoginLinkRow }> {
  return authedWrite('PATCH', `/api/v1/login-links/${id}`, body);
}

export async function deleteLoginLink(id: number): Promise<void> {
  await authedWrite('DELETE', `/api/v1/login-links/${id}`, {});
}
